import { createFileRoute } from '@tanstack/react-router';
import { AdditionalWorkPage } from '@/features/additional-work/AdditionalWorkPage';

// Vooraankondiging meerwerk (docs/additional-work.md). The shell's path check
// keeps the screen from someone without `additional_work_notice`; the API decides.
export const Route = createFileRoute('/_shell/additional-work')({
  component: AdditionalWorkPage,
});
